import {Component} from 'react';
import React from 'react';
import Row from "react-bootstrap/es/Row";
import Col from "react-bootstrap/es/Col";
import CardSub from "../subcomponents/CardSub";

class PackagesTab extends Component {
    constructor(props) {
        /*
        
        */
        super(props);
    }
    
    render() {
        return (
            <div className="page-wrapper">
                <div className="page-breadcrumb">
                    <div className="row">
                        <div className="col-12 d-flex no-block align-items-center">
                            <h3 className="page-title"><i className="mdi mdi-package"></i> Packages</h3>
                        </div>
                    </div>
                </div>

                <div className="container-fluid">
                    <Row>
                        <Col xs={6} sm={5} md={4} lg={3}>
                            <strong><i className="fa fa-tablet-alt"/> Android version</strong>
                        </Col>
                        <Col xs={6} sm={7} md={8} lg={9}>
                            <a href="https://qibipay9b9f.blob.core.windows.net/applications/mdbpay-newest.apk"><i className="fa fa-download"/> Download here!</a>
                        </Col>
                    </Row>
                    <br/>
                    <Row>
                        <Col xs={6} sm={5} md={4} lg={3}>
                            <strong><i className="fa fa-microchip"/> Flexa package (Barionet)</strong>
                        </Col>
                        <Col xs={6} sm={7} md={8} lg={9}>
                            <a href="https://qibipay9b9f.blob.core.windows.net/applications/mifare-newest.zip"><i className="fa fa-download"/> Download here!</a>
                        </Col>
                    </Row>
                    <br/>
                    <Row>
                        <Col xs={6} sm={5} md={4} lg={3}>
                            <strong><i className="fa fa-microchip"/> Raspberry PI version</strong>
                        </Col>
                        <Col xs={6} sm={7} md={8} lg={9}>
                            <a>Coming soon!</a>
                        </Col>
                    </Row>
                </div>
            </div>
        );
    }
}

export default PackagesTab;